const skin_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },   
   
   {
      "question":"Has ##name## been treated with medication in the past 12 months for any skin condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "TREATMENT",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].Yes5[0]",
      "dbqName_no":"F[0].Page_3[0].No5[0]",
      "answer":"",
   },
   {
      "question":"Check all the medication being used in the past 12 months for any skin condition",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": false,
      "refId":1,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "TREATMENT",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Corticosteroids or other medications",
                  "dbqName":"F[0].Page_3[0].treat1[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked1[0]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond1[0]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[1]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[5]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[2]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[6]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[3]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[4]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[0]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration1[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration2[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration3[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Antihistamines",
                  "dbqName":"F[0].Page_3[0].treat2[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked2[0]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond2[0]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[7]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[11]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[8]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[12]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[9]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[10]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[1]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration4[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration5[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration6[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Retinoids",
                  "dbqName":"F[0].Page_3[0].treat3[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked3[0]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond3[0]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[13]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[17]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[14]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[18]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[15]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[16]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[2]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration7[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration8[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration9[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Sympathomimetics",
                  "dbqName":"F[0].Page_3[0].treat4[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked4[0]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond4[0]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[19]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[23]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[20]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[24]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[21]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[22]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[3]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration10[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration11[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration12[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Biologics",
                  "dbqName":"F[0].Page_3[0].treat4[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked4[1]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond4[1]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[25]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[29]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[26]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[30]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[27]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[28]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[4]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration7[1]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration8[1]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration9[1]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Other medication",
                  "dbqName":"F[0].Page_3[0].treat5[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].ifchecked5[0]",
                  "placeholder1":"Please list medication(s)",
                  "text2": "",
                  "dbqName2": "F[0].Page_3[0].speccond5[0]",
                  "placeholder2":"Specify condition medication used for",
                  "subItems": [
                     {
                        "main":"Oral",
                        "dbqName":"F[0].Page_3[0].duration1[31]",
                        "answer":""
                     },
                     {
                        "main":"Injection",
                        "dbqName":"F[0].Page_3[0].duration1[35]",
                        "answer":""
                     },
                     {
                        "main":"Intranasal",
                        "dbqName":"F[0].Page_3[0].duration1[32]",
                        "answer":""
                     },
                     {
                        "main":"Suppository",
                        "dbqName":"F[0].Page_3[0].duration1[36]",
                        "answer":""
                     },
                     {
                        "main":"Topical",
                        "dbqName":"F[0].Page_3[0].duration1[33]",
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].duration1[34]",
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Specify the route of administration",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Other[5]",
                  "subItems2": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_3[0].duration13[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_3[0].duration14[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_3[0].duration15[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total duration of medication use in past 12 months",
               },                        
            ],
            "answer":""
   },

   {
      "question":"Has ##name## had any treatment or procedures other than systemic or topical medication in the past 12 months for any skin condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "TREATMENT",
         number: "3B"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_4[0].Yes50[0]",
      "dbqName_no":"F[0].Page_4[0].No50[0]",
      "answer":"",
   },
   {
      "question":"Check all the treatments or procedures other than systemic or topical medication are being used in the past 12 months for skin condition",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": false,
      "refId":1,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "TREATMENT",
         number: "3B"
      },
      "questions":[
               {
                  "main":"Phototherapy such as ultraviolet-B light (UVB) treatment",
                  "dbqName":"F[0].Page_4[0].treatment11[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "F[0].Page_4[0].Date4[0]",
                  "placeholderDate1":"Date of most recent treatment",
                  "text1": "",
                  "dbqName1": "F[0].Page_4[0].speccond2[0]",
                  "placeholder1":"Specify condition treated",
                  "subItems": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_4[0].duration4[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_4[0].duration5[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_4[0].duration6[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Photochemotherapy (to include PUVA (psoralen with long wave ultraviolet A light)) treatment",
                  "dbqName":"F[0].Page_4[0].Treatment12[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "F[0].Page_4[0].Date3[0]",
                  "placeholderDate1":"Date of most recent treatment",
                  "text1": "",
                  "dbqName1": "F[0].Page_4[0].speccond3[0]",
                  "placeholder1":"Specify condition treated",
                  "subItems": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_4[0].duration7[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_4[0].duration8[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_4[0].duration9[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Electron beam therapy",
                  "dbqName":"F[0].Page_4[0].treament13[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "F[0].Page_4[0].Date2[0]",
                  "placeholderDate1":"Date of most recent treatment",
                  "text1": "",
                  "dbqName1": "F[0].Page_4[0].speccond4[0]",
                  "placeholder1":"Specify condition treated",
                  "subItems": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_4[0].duration10[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_4[0].duration11[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_4[0].duration12[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Intensive light therapy",
                  "dbqName":"F[0].Page_4[0].treat7[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "F[0].Page_4[0].Date1[0]",
                  "placeholderDate1":"Date of most recent treatment",

                  "text1": "",
                  "dbqName1": "F[0].Page_4[0].speccond7[0]",
                  "placeholder1":"Specify condition treated",
                  "subItems": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_4[0].duration19[0]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_4[0].duration20[0]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_4[0].duration21[0]",
                        "answer":""
                     },
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"Other treatment (Specify treatment)",
                  "dbqName":"F[0].Page_4[0].treament13[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "F[0].Page_4[0].Date2[1]",
                  "placeholderDate1":"Date of most recent treatment",
                  "text1": "",
                  "dbqName1": "F[0].Page_4[0].OthertreatmentSpecifytreatment[1]",
                  "placeholder1":"Specify treatment",
                  "text2": "",
                  "dbqName2": "F[0].Page_4[0].speccond4[1]",
                  "placeholder2":"Specify condition treated",
                  "subItems": [
                     {
                        "main":"<6 weeks",
                        "dbqName":"F[0].Page_4[0].duration10[1]",
                        "answer":""
                     },
                     {
                        "main":"6 weeks or more, but not constant",
                        "dbqName":"F[0].Page_4[0].duration11[1]",
                        "answer":""
                     },
                     {
                        "main":"Constant/near-constant",
                        "dbqName":"F[0].Page_4[0].duration12[1]",
                        "answer":""
                     },
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total duration of medication use in past 12 months",
               },
               {
                  "main":"None",
                  "dbqName":"F[0].Page_4[0].No50[0]",
                  "partialField": true,
                  "answer":"",
               },                        
            ],
            "answer":""
   },
   {
      "question":"Indicate ##name##'s visible characteristics lesions due to the skin condition(s); Indicate the approximate total body area and approximate total exposed area affected on current examination ?",
      "sub":"Area of face, neck and hands, check all the apply",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "PHYSICAL EXAM",
         number: "4A"
      },
      "questions":[
               {
                  "main":"Dermatitis",
                  "dbqName":"F[0].Page_4[0].Dermatitis[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none1[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five1[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto1[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto1[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty1[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none2[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five2[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto2[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto2[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty2[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Eczema",
                  "dbqName":"F[0].Page_4[0].Eczema1[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none3[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five3[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto3[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto3[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty3[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none10[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five10[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto10[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto10[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty10[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Dermatophytosis",
                  "dbqName":"F[0].Page_4[0].Psoriasis[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none31[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five31[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto31[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto31[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty31[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none32[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five32[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto32[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto32[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty32[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Bullous disorders",
                  "dbqName":"F[0].Page_4[0].Psoriasis[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none31[1]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five31[1]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto31[1]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto31[1]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty31[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none32[1]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five32[1]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto32[1]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto32[1]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty32[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Cutaneous manifestations of collagen vascular disorders not listed elsewhere",
                  "dbqName":"F[0].Page_4[0].Psoriasis[2]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none31[2]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five31[2]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto31[2]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto31[2]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty31[2]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none32[2]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five32[2]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto32[2]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto32[2]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty32[2]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Psoriasis",
                  "dbqName":"F[0].Page_4[0].Bullousdisorders[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none203[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five203[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto203[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto203[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty203[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_4[0].none303[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_4[0].five303[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_4[0].fiveto303[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_4[0].twentyto303[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_4[0].forty303[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Infections of the skin not listed elsewhere",
                  "dbqName":"F[0].Page_5[0].Acne[3]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none20a[3]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five20a[3]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto20a[3]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto20a[3]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty20a[3]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none30a[3]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five30a[3]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto30a[3]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto30a[3]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty30a[3]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Papulosquamous disorders not listed elsewhere",
                  "dbqName":"F[0].Page_5[0].Dermatitis[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none1[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five1[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto1[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto1[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty1[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none2[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five2[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto2[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto2[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty2[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Diseases of keratinization",
                  "dbqName":"F[0].Page_5[0].Eczema1[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none3[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five3[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto3[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto3[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty3[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none10[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five10[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto10[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto10[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty10[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Discoid lupus erythematosus",
                  "dbqName":"F[0].Page_5[0].Psoriasis[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none31[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five31[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto31[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto31[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty31[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none32[0]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five32[0]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto32[0]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto32[0]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty32[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },
               {
                  "main":"Other",
                  "dbqName":"F[0].Page_5[0].Acne[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_5[0].Date5[0]",
                  "placeholder1": "Indicate diagnosis",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none20a[1]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five20a[1]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto20a[1]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto20a[1]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty20a[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Total body area",
                  "subItems2": [
                     {
                        "main":"None",
                        "dbqName":"F[0].Page_5[0].none30a[1]",
                        "answer":""
                     },
                     {
                        "main":"<5%",
                        "dbqName":"F[0].Page_5[0].five30a[1]",
                        "answer":""
                     },
                     {
                        "main":"5% to <20%",
                        "dbqName":"F[0].Page_5[0].fiveto30a[1]",
                        "answer":""
                     },
                     {
                        "main":"20% to 40%",
                        "dbqName":"F[0].Page_5[0].twentyto30a[1]",
                        "answer":""
                     },
                     {
                        "main":">40%",
                        "dbqName":"F[0].Page_5[0].forty30a[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer2":"",
                  "subItems2Label" :"Total exposed area",
               },               
            ]
   },
   {
      "question":"Does ##name## have a skin condition currently without any visible characteristic lesions at the time of the examination?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "PHYSICAL EXAM",
         number: "4A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_5[0].Papa[0]",
      "dbqName_no":"F[0].Page_5[0].Papa[1]",
      "answer":"",
   },
   
   {
      "question":"Does ##name## have any skin condition of Acne?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_5[0].skincondition1[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Does ##name## have attacks of colic due to upper urinary tract urolithiasis?",
      "sub":"",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": false,
      "refId":1,
      "cols": 2,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "questions":[
         {
            "main":"Superficial acne (comedones, papules, pustules) of any extent",
            "dbqName":"F[0].Page_5[0].indicate1[0]",
            "answer":"",
         },  
         {
            "main":"Deep acne (deep inflamed nodules and pus-filled cysts)",
            "dbqName":"F[0].Page_5[0].indicate2[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Affects less than 40% of face and neck",
                  "dbqName":"F[0].Page_5[0].indicate3[0]",
                  "answer":""
               },
               {
                  "main":"Affects 40% or more of face and neck",
                  "dbqName":"F[0].Page_5[0].indicate4[0]",
                  "answer":""
               },
               {
                  "main":"Affects body areas other than face and neck",
                  "dbqName":"F[0].Page_5[0].indicate5[0]",
                  "answer":""
               }
            ],
         }     
      ],
      "answer":""
   },

   {
      "question":"Does ##name## have any skin condition of Alopecia areata?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_5[0].skincondition4[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate severity and and amount of hair loss due to Alopecia areata",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":1,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
     "textarea": false,
      // "small": true, //incase without textarea show tile
      "cols": 2,
      "height": "auto",
      "questions":[
         {
            "main":"Hair loss limited to scalp and face",
            "dbqName":"F[0].Page_5[0].hair1[0]",
            "answer":"",
         },
         {
            "main":"Loss of all body hair",
            "dbqName":"F[0].Page_5[0].hair2[0]",
            "answer":"",
         },
         {
            "main":"Other, describe",
            "dbqName":"F[0].Page_5[0].hair3[0]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "F[0].Page_5[0].Otherdescribe5[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Does ##name## have any skin condition of Urticaria, chronic?",
      "sub":"",
      "type":"yesnoouter",
      "show": true,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "presidence":"Yes",
      "outer_ref": 3,
      "dbqName_yes":"F[0].Page_6[0].skincondition6[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Does ##name## have ever had a break in treatment?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "presidence":"Yes",
      "ref":1,
      "outer_refId":1,
      "dbqName_yes":"F[0].Page_6[0].Yes240[0]",
      "dbqName_no":"F[0].Page_6[0].No240[0]",
      "answer":"",
   },
   {
      "question":"Does ##name## experiences symptoms at least twice a week for six weeks or more?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "presidence":"Yes",
      "refId":1,
      "outer_refId":2,
      "dbqName_yes":"F[0].Page_6[0].Yes240[1]",
      "dbqName_no":"F[0].Page_6[0].No240[1]",
      "answer":"",
   },
   {
      "question":"Indicate the type of treatment ##name## is currently receiving for Urticaria",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "show": false,
      "outer_refId":3,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "SPECIFIC SKIN CONDITIONS",
         number: "5"
      },
      "questions":[
         {
            "main":"First line treatment",
            "dbqName":"F[0].Page_6[0].response4a2[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Antihistamines",
                  "dbqName":"F[0].Page_6[0].response4a3[0]",
                  "colWidth": 5,
                  "answer":""
               },
               {
                  "main":"Other",
                  "dbqName":"F[0].Page_6[0].response4a4[0]",
                  "colWidth": 3,
                  "subItemLinked": true,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"First line treatment type",
            "subItemOther": false,
            "textOther": "",
            "placeholderOther":"First line treatment type",
            "dbqNameOther": "F[0].Page_6[0].Other[0]",
         },
         {
            "main":"Second line treatment",
            "dbqName":"F[0].Page_6[0].response4a2[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Corticosteroids",
                  "dbqName":"F[0].Page_6[0].response1[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Sympathomimetics",
                  "dbqName":"F[0].Page_6[0].response2[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Leukotriene inhibitors",
                  "dbqName":"F[0].Page_6[0].response3[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Neutrophil inhibitors",
                  "dbqName":"F[0].Page_6[0].response2[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"TopicaThyroid hormonel",
                  "dbqName":"F[0].Page_6[0].response3[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Other",
                  "dbqName":"F[0].Page_6[0].response3[2]",
                  "colWidth": 4,
                  "subItemLinked": true,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Second line treatment type",
            "subItemOther": false,
            "textOther": "",
            "placeholderOther":"Second line treatment type",
            "dbqNameOther": "F[0].Page_6[0].Other[1]",
         },
         {
            "main":"Third line treatment",
            "dbqName":"F[0].Page_6[0].response4a2[2]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Plasmapheresis",
                  "dbqName":"F[0].Page_6[0].response1[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Immunotherapy",
                  "dbqName":"F[0].Page_6[0].response2[2]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Immunosuppressives",
                  "dbqName":"F[0].Page_6[0].response3[3]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Other",
                  "dbqName":"F[0].Page_6[0].response3[5]",
                  "colWidth": 4,
                  "subItemLinked": true,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Third line treatment type",
            "subItemOther": false,
            "textOther": "",
            "placeholderOther":"Third line treatment type",
            "dbqNameOther": "F[0].Page_6[0].Other[2]",
         },                      
      ],
      "answer":""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "6",
         title: "REMARKS",
         number: "9"
      },
      "options":[],
      "dbqName":"F[0].Page_8[0].REMARKSifany[0]",
      "answer":""
   },
]
   
    export default skin_questions ;